import {
  AdminMethods as RewardFeederAdminMethods,
  SetRewardParamsForTier as rewardFeederSetRewardParamsForTier,
  RemoveTierParams as rewardFeederRemoveTierParams,
  ChangeOwner as rewardFeederChangeOwner,
} from './admin';
import {
  GetterMethods as RewardFeederUserMethods,
  GetRewardParams as rewardFeederGetRewardParams,
  GetReward as rewardFeederGetReward,
} from './getters';

const NamedAdminMethods = {
  rewardFeederSetRewardParamsForTier,
  rewardFeederRemoveTierParams,
  rewardFeederChangeOwner,
};
const NamedUserMethods = {
  rewardFeederGetRewardParams,
  rewardFeederGetReward,
};

export const RewardFeederMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
}
export {
  RewardFeederAdminMethods,
  RewardFeederUserMethods
};
export default RewardFeederMethods;